import Blocs from "./Blocs";
export default Blocs;
